import createAPI from "@/libs/create-api.js";
// 弹框事件
const DIALOG_EVENTS = ['open', 'opened', 'close', 'closed'];
// 登录事件
const LOGIN_EVENTS = ['success'];
export default function addLoginDialog(Vue, LoginDialog) {
    createAPI(Vue, LoginDialog, [...DIALOG_EVENTS, ...LOGIN_EVENTS], true)
}